module.exports = __webpack_public_path__ + "assets/media/m2.f6a28680.mp4";